'use client'

/**
 * The only boundary that catches a throw inside RootLayout or <Providers>
 * itself. It must render its OWN <html><body> and cannot rely on tokens,
 * hooks, or any provider — everything here is inline and self-contained.
 */
export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100dvh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
          fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
          color: '#101323',
          background: '#FFFFFF',
          textAlign: 'center',
          padding: 24,
        }}
      >
        <p style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>Something went wrong on our end</p>
        <p style={{ fontSize: 14, color: '#4E5BA6', margin: 0 }}>
          We&apos;re looking into it. Please try again shortly.
        </p>
        <div style={{ display: 'flex', gap: 8 }}>
          <button
            onClick={() => reset()}
            style={{
              padding: '8px 16px',
              borderRadius: 10,
              border: 'none',
              background: '#444CE7',
              color: '#FFFFFF',
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            Retry
          </button>
          <button
            onClick={() => window.location.assign('/')}
            style={{
              padding: '8px 16px',
              borderRadius: 10,
              border: '1px solid #C8CCE5',
              background: '#FFFFFF',
              color: '#363F72',
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            Go back
          </button>
        </div>
      </body>
    </html>
  )
}
